export default {
  format: (string) => {
    return string
      .replace(/[^\d]/g, '')
      .replace(/(.{4})/g, '$1 ')
      .trim()
      .substring(0, 23);
  }
};
